export default __webpack_public_path__ + "static/media/flick-the-deck.b9a2bdb1.png";